<div class="container flex ion-text-center fd-col">

  <img class="img mapfre-mb-sm"
    src="assets/images/result/info.svg"
    alt="Éxito en el registro" />

  <div class="mapfre-fs-s dark mapfre-fw-500 mb-20">
    {{ 'BUSINESSES.REGISTER.SUCCESS.DESCRIPTION' | translate }}
  </div>

  <div class="mapfre-fs-s dark mapfre-fw-500 mb-20">
    {{ obfuscatedEmail}}
  </div>

  <div class="mapfre-fs-xs-r medium">
    {{ 'BUSINESSES.REGISTER.SUCCESS.SUBDESCRIPTION' | translate }}
  </div>
  <div>
    <a (click)="forwardEmail()"
      class="mapfre-fs-xs-r mapfre-mt-xxs">{{ 'BUSINESSES.REGISTER.SUCCESS.LINK1' | translate }}</a>
  </div>
  <div class="mapfre-mb-sm">
    <a (click)="changeEmail()"
      class="mapfre-fs-xs-r mapfre-mt-xxs">{{ 'BUSINESSES.REGISTER.SUCCESS.LINK2' | translate }}</a>
  </div>

  <div class="buttons">
    <ion-button (click)="onContinue()"
      [disabled]="false">
      {{ 'UNDERSTOOD' | translate }}
    </ion-button>
  </div>
</div>